var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ask-suggested-questions"},_vm._l((_vm.questions),function(question,index){return _c('AskListItemQuestion',{key:index,attrs:{"question":question,"clickable":_vm.clickable},on:{"trigger-ask":function($event){return _vm.$emit('trigger-ask', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }